import { Outlet, ScrollRestoration, useMatch } from 'react-router-dom'

import { PularParaConteudo } from '@/shared/ui/PularParaConteudo.jsx'
import { Navbar } from './Navbar.jsx'
import { Rodape } from './Rodape.jsx'
import { BotaoWhatsAppFlutuante } from './BotaoWhatsAppFlutuante.jsx'

export default function LayoutPublico() {
  // Na página de produto o rodapé do mobile pertence à BarraCtaProduto.
  const naPaginaDeProduto = useMatch('/bicicletas/:slug') !== null

  return (
    <>
      <PularParaConteudo />
      <Navbar />
      <main id="conteudo">
        <Outlet />
      </main>
      <Rodape />
      <BotaoWhatsAppFlutuante ocultoNoMobile={naPaginaDeProduto} />
      {/* Restaura a posição de scroll ao voltar — sem isso, voltar do detalhe
          para o catálogo joga o visitante no topo. */}
      <ScrollRestoration />
    </>
  )
}
